import { network } from 'services/network';

export const insightEmailNotification = (params) => {
    return network.post('api/bo/notification/insightEmailNotification', params).then((response) => {
        return response.data;
    });
};
